.recentJobs {
  color: rgba(0, 0, 0, 0.87);
}

.recentJobsContainer {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  @media (min-width: 1200px) {
    max-width: 1140px;
  }

  @media (min-width: 992px) {
    max-width: 960px;
  }
  @media (min-width: 768px) {
    max-width: 720px;
  }
  @media (min-width: 576px) {
    max-width: 540px;
  }
}

.recentJobsRow {
  display: flex;
  flex-direction: column;
  padding: 1rem;

  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 1rem;
    padding: 1rem;
  }
}

.recentJobsHeader {
  margin-bottom: 1rem;
  font-family: "Lato";
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
}

.recentJobsCell {
  margin-bottom: 1.5rem !important;
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;

  @media (min-width: 768px) {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
}

.recentJobsCard {
  box-shadow: 0 10px 10px rgba(0, 0, 0, 0.22);
  cursor: pointer;
  width: 100%;
  background-color: #fff;
  display: block;
  border-radius: 0.3rem;
  overflow: hidden;
  margin-bottom: 12px;
  margin-bottom: 0.75rem;
  color: rgba(0, 0, 0, 0.87);
  padding: 1.25rem;

  @media (min-width: 576px) {
    min-height: auto;
  }
  @media (min-width: 768px) {
    min-height: 125px;
  }
}

.recentJobsCard:hover {
  transition: box-shadow 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.recentJobsCardBody {
  width: 100%;
  display: block;
}

.recentJobsCardContent {
  padding: 1.25rem;
}

.recentJobsText {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recentJobsTitle {
  color: #2095f3;
  text-decoration: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 700;
  line-height: 1.2;
  font-size: 1.25rem;
}
.recentJobsTitle:hover {
  text-decoration: underline;
}
.recentJobsBtnContainer {
  display: flex;
  width: 100%;
  padding: 1rem;
}
